import { exposeSerialIndexDevHelpers } from "./scanSerialIndex";

export function exposeDevHelpers() {
  if (typeof window === "undefined" || process.env.NODE_ENV === "production") return;
  exposeSerialIndexDevHelpers();
}
